import React from "react";
import { IProductDetailsProps } from "@model/Products.model";
import styles from "./Product.module.css";

const ProductDetails: React.FC<IProductDetailsProps> = ({ details }) => {
  return (
    <section className={styles.productDetailsSP} data-testid="product-details">
      <h2 className={styles.sectionTitleSP} data-testid="product-details-title">
        Details
      </h2>
      <p className={styles.longTextSP} data-testid="product-details-text">
        {details}
      </p>
    </section>
  );
};

export default ProductDetails;
